import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden border border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20production%20scene%2C%20professional%20camera%20equipment%20with%20warm%20studio%20lighting%2C%20elegant%20film%20set%20atmosphere%20with%20soft%20golden%20illumination%2C%20creative%20filmmaking%20environment%2C%20artistic%20composition%20with%20rich%20warm%20tones%20and%20gentle%20bokeh%20background&width=1200&height=800&seq=about-visual-01&orientation=landscape"
                alt="爱豆影视 - 平台介绍"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              {aboutData.title}
            </h2>
            <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4 mb-8">
              {aboutData.desc.split('\n\n').map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {aboutData.stats.map((stat) => (
                <div
                  key={stat.label}
                  className="text-center p-4 bg-background-100 rounded-xl border border-background-200/60"
                >
                  <div className="text-xl md:text-2xl font-bold text-primary-400 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}